import NAME from "./constants";

export const getData = store => store[NAME].data;
export const getQuestions = store => store[NAME].questions;
export const getAnswers = store => store[NAME].answers;
export const getOnaData = store => store[NAME].onaData;
export const getIsNPS = store => store[NAME].isNPS;
export const getIsONA = store => store[NAME].isONA;
export const getIsAnonymous = store => store[NAME].isAnonymous;
export const getIsLoading = store => store[NAME].isLoading;
export const getLocale = store => store[NAME].locale;
export const getDateFormat = store => store[NAME].dateFormat;